__turbopack_context__.v({
  "button": "_bPAea_button",
  "content": "_bPAea_content",
  "icon": "_bPAea_icon",
  "tooltip": "_bPAea_tooltip",
});
